// extracted by mini-css-extract-plugin
export default {"backIcon":"yEhPSTFuWioAXIjdOZa3","modal":"E82MJoPkMu_z7S7ikURB","info":"EmzQqWmZmTIwIW4NOD_J","dotIndicator":"bu7VWGn5ZaZdgtTlu2_z"};